import React, { Component } from "react";
import PropTypes from "prop-types";
import InputRow from "./InputRow";
import Loading from "./Loading";

export default class Address extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addressType: "",
      addressTypeData: [],
      addressLine1: props.line1 || "",
      addressLine2: props.line2 || "",
      selectedCountry: props.country || "",
      cityData: [],
      regionData: [],
      selectedCity: props.city || "",
      selectedRegion: props.region || "",
      dormPlanInterest: props.dormPlanInterest || false,
      loading: true,
      error: "",
      regionInput: props.regionInput || "",
    };
    this.fetchCity2 = this.fetchCity2.bind(this);
    this.fetchRegion2 = this.fetchRegion2.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    const { regionData, selectedRegion, regionInput } = this.state;

    // ⬅️ Dropdown ➜ Text field
    if (
      prevState.regionData.length > 0 && // we *had* a dropdown
      regionData.length === 0 && // now it's gone
      selectedRegion !== "" // stale value to clear
    ) {
      this.setState({ selectedRegion: "" });
    }

    // ⬅️ Text field ➜ Dropdown
    if (
      prevState.regionData.length === 0 && // we *had* a text box
      regionData.length > 0 && // now we have a dropdown
      regionInput !== "" // stale free text to clear
    ) {
      this.setState({ regionInput: "" });
    }
  }

  componentDidMount() {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/AddressInformation/GetAddressTypes`
    )
      .then((res) => res.json())
      .then((res) => {
        const homeAddress = res.find((ele) => ele.value === "Home Address");
        const homeAddressId = homeAddress ? homeAddress.Id : "";

        this.setState({
          addressTypeData: res,
          addressType: this.props.addressType || homeAddressId,
          loading: false,
        });

        this.props.getDefaultValue(
          "Add",
          this.props.addressType || homeAddressId
        );
        if (this.props.country) {
          this.fetchCity2(this.props.country || "");
        }
        if (this.props.city) {
          this.fetchRegion2(this.props.city);
        }
      })
      .catch(console.error);
  }

  fetchCity = async (countryId) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/AddressInformation/GetCitiesByCountry?countryid=${countryId}`
      ).then((r) => r.json());
      this.setState({ cityData: res });
    } catch (err) {
      console.error(err);
    }
  };

  fetchRegion = async (countryId) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/AddressInformation/GetCountiesByCountry?countryid=${countryId}`
      ).then((r) => r.json());
      this.setState({ regionData: res });
    } catch (err) {
      console.error(err);
    }
  };

  fetchCity2 = async (countryId) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/AddressInformation/GetCitiesByCountry?countryid=${countryId}`
      ).then((r) => r.json());
      this.setState({ cityData: res, selectedCity: this.props.city });
    } catch (err) {
      console.error(err);
    }
  };

  fetchRegion2 = async (countryId) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/AddressInformation/GetCountiesByCountry?countryid=${countryId}`
      ).then((r) => r.json());
      this.setState({
        regionData: res,
        selectedRegion: this.props.region,
        regionInput: this.props.regionInput,
      });
    } catch (err) {
      console.error(err);
    }
  };

  updateCollectedState = (updates) => {
    this.setState(updates, () => {
      const {
        addressType,
        addressLine1,
        addressLine2,
        selectedCountry,
        selectedCity,
        selectedRegion,
        dormPlanInterest,
        regionInput,
      } = this.state;

      this.props.collectState("Add", {
        addressType,
        addressLine1,
        addressLine2,
        selectedCountry,
        selectedCity,
        selectedRegion,
        dormPlanInterest,
        regionInput,
      });
    });
  };

  render() {
    const {
      addressTypeData,
      cityData,
      regionData,
      addressType,
      addressLine1,
      addressLine2,
      selectedCountry,
      selectedCity,
      selectedRegion,
      regionInput,
      dormPlanInterest,
      loading,
      error,
    } = this.state;

    const validationError = this.props.error;

    if (loading) return <Loading />;

    return (
      <div>
        <p style={{ color: "black" }}>Please provide your current address</p>
        <p style={{ color: "black" }}>
          Click next to navigate to the next section
        </p>
        <p style={{ color: "red" }}>{error}</p>
        {/* Hidden address type input */}
        <span className="hidden">
          <InputRow
            name="select"
            rowName="Address Type"
            required="*"
            value={addressType}
            onChange={(val) => this.updateCollectedState({ addressType: val })}
            data={addressTypeData}
            errMsg={validationError.addressType || ""}
          />
        </span>
        <InputRow
          rowName="Country"
          name="select"
          data={this.props.countryData}
          value={selectedCountry}
          required="*"
          onChange={async (val) => {
            this.setState({
              regionData: "",
              selectedRegion: "",
              regionInput: "",
            });
            this.updateCollectedState({
              selectedCountry: val,
              selectedCity: "",
              selectedRegion: "",
              regionData: [], // ⬅️ instantly hide the dropdown
              regionInput: "",
            });
            await this.fetchCity(val);
          }}
          errMsg={validationError.selectedCountry || ""}
        />
        {Number(selectedCountry) === 1 && (
          <InputRow
            rowName="District"
            name="select"
            data={cityData}
            value={selectedCity}
            required="*"
            onChange={async (val) => {
              this.setState({
                regionData: "",
                selectedRegion: "",
                regionInput: "",
              });
              this.updateCollectedState({
                selectedCity: val,
                selectedRegion: "", // ⬅️  clear immediately
                regionInput: "", //     (optional)
                regionData: [],
              });
              await this.fetchRegion(val);
            }}
            errMsg={validationError.selectedCity || ""}
          />
        )}
        {regionData.length > 0 ? (
          <InputRow
            rowName="City"
            name="select"
            data={regionData}
            value={selectedRegion}
            required="*"
            onChange={(val) =>
              this.updateCollectedState({
                selectedRegion: val,
                regionInput: "", // wipe text field
              })
            }
            errMsg={validationError.selectedRegion || ""}
          />
        ) : (
          <InputRow
            rowName="City"
            name="text"
            value={regionInput}
            required="*"
            onChange={(val) =>
              this.updateCollectedState({
                regionInput: val,
                selectedRegion: "", // wipe dropdown value
              })
            }
            errMsg={validationError.regionInput || ""}
          />
        )}
        <InputRow
          rowName="Street"
          name="text"
          value={addressLine2}
          onChange={(val) => this.updateCollectedState({ addressLine2: val })}
        />
        <InputRow
          rowName="Building"
          name="text"
          required="*"
          value={addressLine1}
          onChange={(val) => this.updateCollectedState({ addressLine1: val })}
          errMsg={validationError.addressLine1 || ""}
        />
        <button className="save" onClick={this.props.onSave}>
          Next
        </button>
      </div>
    );
  }
}

Address.propTypes = {
  onSave: PropTypes.func.isRequired,
  countryData: PropTypes.array.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  addressType: PropTypes.number,
  line1: PropTypes.string,
  line2: PropTypes.string,
  country: PropTypes.number,
  city: PropTypes.number,
  region: PropTypes.number,
  regionInput: PropTypes.string,
  collectState: PropTypes.func,
  error: PropTypes.object,
  getDefaultValue: PropTypes.func,
  dormPlanInterest: PropTypes.bool,
};
